export enum WizardSteps {
  BasketOverview,
  Payment,
  PaymentStatus,
  Extension
}
